export interface BaseOption {
  id: string;
  name: string;
  regionId?: number;
}

export interface IdentificationType {
  id: string;
  name: string;
  rules: unknown;
}

export interface IdentificationTypeResponse {
  identificationTypes: IdentificationType[];
}

export interface OptionsResponse {
  tenanCountry: BaseOption;
  countries: BaseOption[];
  regions: BaseOption[];
  cities: BaseOption[];
  communes: BaseOption[];
  healthInstitutions: BaseOption[];
  identificationTypes: BaseOption[];
  campuses: BaseOption[];
  schools: BaseOption[];
  // Statics
  genders: BaseOption[];
  areaTypes: BaseOption[];
  healthSystems: BaseOption[];
  maritalStatus: BaseOption[];
}

export type OptionsResponseKey = keyof OptionsResponse;

export enum TeacherRoles {
  TUTOR = 'TTR',
  TEACHER = 'TCH',
  TEACHER_TUTOR = 'TCH_TTR',
}

export const teacherRolesOptions = [
  { value: TeacherRoles.TUTOR, label: 'Tutor' },
  { value: TeacherRoles.TEACHER, label: 'Docente' },
  { value: TeacherRoles.TEACHER_TUTOR, label: 'Docente - Tutor' },
];

export type TeacherRole = typeof TeacherRoles[keyof typeof TeacherRoles];
